





























import Vue from "vue";

export default Vue.extend({
	props: ["profileoccupations", "occupations"],

	data() {
		return {
			selected: [] as any,
		};
	},

	watch: {
		profileoccupations: {
			handler: async function handle(newVal) {
				if (newVal) {
					this.selected = newVal;
				}
			},
		},
	},

	methods: {
		handleOk(bvModalEvt: any) {
			bvModalEvt.preventDefault();
			this.handleSubmit();
		},
		handleSubmit() {
			this.$emit("updateAlat", this.selected);
			this.$nextTick(() => {
				this.$bvModal.hide("pick-occupations");
			});
		},
		hideModal() {
			this.$bvModal.hide("pick-occupations");
		},
		//toggleAml(h:any) {
		// if(!this.selected.includes(h.value)) {
		//     this.selected = this.selected.filter((x:any) => {
		//         x.paaNro != h.value.uid
		//     })
		// }
		// else {
		//     this.selected = this.selected.filter((x:any) => {
		//         x.paaNro != h.value.uid
		//     })
		//     h.alat.forEach((ala:any) => {
		//         this.selected.push(ala)
		//     });
		// }
		// if (!this.selected.includes(h.value)) {
		//     this.selected = this.selected.filter((x:any)=> {
		//         x.paaNro != h.value.uid
		//     })
		// }
		// else {
		//     this.selected = this.selected.filter((x:any) => {
		//         x.paaNro != h.value.uid
		//     })
		//     h.alat.forEach((ala:any) => {
		//         this.selected.push(ala)
		//     });
		// }
		//}
	},
});
